// extracted by mini-css-extract-plugin
module.exports = {"root":"MainHeader_root__3CXxI","logoImg":"MainHeader_logoImg__3xmfN","notifZone":"MainHeader_notifZone__TEHXp"};